export default "__VITE_PUBLIC_ASSET__c0a4db99__"